import { addMethod, NumberSchema } from 'yup'

export const emptyNumberAsUndefinedTransform = () => {
  addMethod(NumberSchema, 'emptyAsUndefined', function emptyAsUndefined() {
    return this.transform(value => (isNaN(Number(value)) ? undefined : Number(value)))
  })
}
